import { render, staticRenderFns } from "./newsletter.vue?vue&type=template&id=e4dec436"
import script from "./newsletter.vue?vue&type=script&lang=js"
export * from "./newsletter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/johnmartin/Repos/whitefox-shopify-theme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e4dec436')) {
      api.createRecord('e4dec436', component.options)
    } else {
      api.reload('e4dec436', component.options)
    }
    module.hot.accept("./newsletter.vue?vue&type=template&id=e4dec436", function () {
      api.rerender('e4dec436', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/newsletter.vue"
export default component.exports